import * as React from "react";
import SaveDialogLayout from "components/DialogLayout/SaveDialogLayout";
import repository from "client/repository";
import {DataBaseComponent, DataBaseComponentState} from "components/DataBaseComponent";
import {Text} from "components/form";
import {DeleteOutboundPrivateLinkDnsRecordRequest} from "~/client/resources/deleteOutboundPrivateLinkDnsRecordRequest";
import { Callout } from "@octopusdeploy/design-system-components";

interface Props {
    instanceId: string;
    onTaskStarted: (taskId: string) => void;
}

interface State extends DataBaseComponentState {
    request: DeleteOutboundPrivateLinkDnsRecordRequest;
}

class DeleteOutboundPrivateLinkDnsRecordDialog extends DataBaseComponent<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            request: {
                PrivateDnsZoneName: "",
                DnsRecordName: ""
            }
        };
    }

    render() {
        return <SaveDialogLayout title={"Delete Private DNS Zone Resources"}
            onSaveClick={() => this.delete()}
            errors={this.state.errors}
            saveButtonLabel={"Delete"}
            busy={this.state.busy}>
            <Callout type="warning" title="Warning">
                This action will delete the DNS record of the specified Private DNS Zone name.
            </Callout>
            <Text label="Private DNS Zone Name"
                value={this.state.request.PrivateDnsZoneName}
                hintText={"e.g. mydomain.com"}
                onChange={PrivateDnsZoneName => this.modifyRequestState({PrivateDnsZoneName})}
            />
            <Text label="Record Set Name (Sub Domain)"
                value={this.state.request.DnsRecordName}
                hintText={"e.g. subdomain"}
                onChange={DnsRecordName => this.modifyRequestState({DnsRecordName: DnsRecordName})}
            />
        </SaveDialogLayout>;
    }

    private modifyRequestState(request: Partial<DeleteOutboundPrivateLinkDnsRecordRequest>): void {
        this.setState((prevState: State) => ({request: {...prevState.request, ...request}}));
    }

    private async delete(): Promise<boolean> {
        return await this.doBusyTask(async () => {
            const taskId = await repository.HostedInstances.deleteOutboundPrivateLinkDnsRecord(this.props.instanceId, this.state.request);
            this.props.onTaskStarted(taskId);
        });
    }
}

export default DeleteOutboundPrivateLinkDnsRecordDialog;
